import styled, { css } from 'styled-components'
import theme from 'styles/theme'

export const ProductCardList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.columnDirection};

  html[dir='rtl'] & {
    flex-direction: row-reverse;
  }
`

export const ProductCardListItem = styled.div`
  display: flex;
  margin-right: 7px;
  position: relative;

  html[dir='rtl'] & {
    margin-right: 0;
    margin-left: 7px;
  }

  &::before {
    background-color: ${(props) => props.theme.colors.sagemedium};
    content: '';
    display: ${(props) => (props.strikethrough ? 'block' : 'none')};
    height: 1px;
    left: 0;
    position: absolute;
    right: 0;
    bottom: 58%;
    transform: translateY(50%);

    ${({ isWebkit }) =>
      isWebkit &&
      css`
        bottom: 50%;
      `}
  }

  color: ${(props) =>
    props.faded
      ? `${theme.colors.sagemedium}`
      : `${props.theme.colors.btnMainColor}`};
`

export const ProductCardLabel = styled.span`
  display: inline-block;
  margin-right: 4px;
`

const getMarginTop = (index) => {
  if (index === 0) return '7px'
  if (index === 1) return '12px'
  return '0px'
}

export const ProductCardListItemWrapper = styled.div`
  display: flex;
  align-items: baseline;
  margin-top: ${(props) => getMarginTop(props.index)};

  html[dir='rtl'] & {
    align-items: baseline;
  }
`
